import { useMemo } from "react";
import { CountryCode } from "../types/kpiConfigTypes";
import { getKpis, kpiExists, moduleExists, hasKpis } from "../kpis/kpiUtils";
import { useStores } from "../context/storesContext";

export function useKpiVisibility() {
    const { selectedStore } = useStores();
    const country = useMemo<CountryCode | null>(() => {
        return (selectedStore?.countryKey as string | undefined) 
        ?.substring(0, 2).toUpperCase() as CountryCode ?? null;
    }, [selectedStore?.countryKey]);

    const apiKpi = useMemo(() => {
        if (!country) {
            return {
                country: null,
                getKpis: () => [],
                isKpiExists: () => false,
                hasKpis: () => false,
                isModuleExists: () => false,
            };
        }

        return {
            country,
            getKpis: (moduleName: string) => getKpis(country, moduleName),
            isKpiExists: (moduleName: string, kpiName: string) => kpiExists(country, moduleName, kpiName),
            hasKpis: (moduleName: string) => hasKpis(country, moduleName),
            isModuleExists: (moduleName: string) => moduleExists(country, moduleName),
        };
    }, [country]);

  return apiKpi;
}
